import React from 'react';

import { CommentCount } from 'gatsby-plugin-disqus';

import { withStyles } from '@material-ui/core/styles';

import CommentIcon from './assets/comment.svg';

const styles = theme => ({
  root: {
    fontFamily: 'Raleway',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.25,
    color: '#6a27e8',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 9,
    },
  },
  icon: { marginRight: 4 },
});

const Comments = ({ classes, config }) => (
  <div className={classes.root}>
    <img src={CommentIcon} alt="comment-icon" className={classes.icon} />
    <CommentCount config={config} placeholder="0 Comments" />
  </div>
);

export default withStyles(styles)(Comments);
